export default __webpack_public_path__ + "static/media/myntra.de696020.png";